<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter,
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter,
    Loader,

  },
  data() {

    return {
      title: "Logística Reversa",
      items: [
        {
          text: "Serviços",
          href: "/"
        },
        {
          text: "Logística Reversa",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      errosValid: null,
      showModalStatus: false,
      editData: {},
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      statusFilter: 'TODOS',
      showStatusMenu: false,
    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {
    acompanharStatusPedido() {
      console.log('acompanharStatus')
      api.get(`${getBaseUrl()}api/acompanharpedidologrev`, {
        params: {
          'id': this.editData.id
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Status atualizado!",
          text: response.data,
          showConfirmButton: false,
          timer: 3500
        })
        
        this.updating = true
        this.atualizaDataList()
        this.updating = false
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
    },


    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro)
          .format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro)
          .format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Logística Reversa: ${dtIniFormated} - ${dtFimFormated}`
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    setStatusFilter(status) {
      this.statusFilter = status;
      this.showStatusMenu = false;
      this.atualizaDataList();
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date()).add(-7, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
                .format('YYYY-MM-DD')
            
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const paramsReq = {
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
      }
      if (this.statusFilter) {
        paramsReq.status = this.statusFilter;
      }

      console.log('paramsReq')
      console.log(paramsReq)

      api.get(`${getBaseUrl()}api/corlogrevs`, {
        params: paramsReq
      }).then(response => {
        console.log('response.data')
        console.log(response)
        this.dataList = response.data[0]
        this.totalCount = response.data[1]
      })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

    solicitapostagem() {
      console.log('solicitapostagem')
      let ids = this.dataGrid.getSelectedRowKeys()
      if (ids.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Selecione ao menos um registro para solicitar a logística reversa!",
          showConfirmButton: false,
          timer: 3500
        })
        return
      } else {
        Swal.fire({
          title: 'Confirma solicitação de logística reversa para os itens selecionados?',
          text: `Itens selecionados: ${ids.length}`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, solicitar!',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            this.executaSolicitacaoLogRev(ids)
          }
        })
      }
    },
    
    executaSolicitacaoLogRev(ids) {
      console.log(ids)
      api.post(`${getBaseUrl()}api/registralogrev`, {
        params: {
          'ids': ids
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Logistica reversa solicitada!",
          text: response.data,
          showConfirmButton: false,
          timer: 3500
        })
      })
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>
    Filtro de Status:
      <div>
        <DxToolbar>
          <DxItem location="before" widget="dxButton">
            <div class="dropdown" style="display:inline-block;">
              <button type="button"
                      class="btn btn-outline-primary dropdown-toggle"
                      @click="showStatusMenu = !showStatusMenu"
                      aria-haspopup="true"
                      aria-expanded="false">
                {{ statusFilter ? statusFilter : 'TODOS' }}
              </button>
              <div class="dropdown-menu" :class="{ show: showStatusMenu }" style="min-width:160px;">
                <a class="dropdown-item" href="#" @click.prevent="setStatusFilter(null)">TODOS</a>
                <a class="dropdown-item" href="#" @click.prevent="setStatusFilter('CRIADO')">CRIADO</a>
                <a class="dropdown-item" href="#" @click.prevent="setStatusFilter('PROCESSADO')">PROCESSADO</a>
                <a class="dropdown-item" href="#" @click.prevent="setStatusFilter('RASTREANDO')">RASTREANDO</a>
              </div>
            </div>
          </DxItem>
        </DxToolbar>
      </div>
    <p></p>
    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="check"
              text="Solicitar"
              hint="Solicitar logistica reversa(Correios)"
              :on-click="solicitapostagem"/>
        </DxItem>

        <DxItem
          location="before"
          widget="dxButton">
          <DxButton
            icon="search"
            text="Acompanhar Pedido Status"
            hint="Acompanhar status do pedido de logística reversa"
            :on-click="acompanharStatusPedido"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :keyExpr="'id'"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strCorLogRevList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />



        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem"
            caption="Origem"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codigo"
            caption="NF"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem_id"
            caption="Origem_ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codserv"
            caption="Serviço"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="prod1"
            caption="Produto 1"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destnome"
            caption="Destinatário"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="destcnpj"
            caption="CNPJ"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="destcidade"
            caption="Cidade"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="remetnome"
            caption="Remetente"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="remetcnpj"
            caption="CNPJ"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="remetcidade"
            caption="Cidade"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
          data-field="numcoleta"
          caption="Autorização de postagem"
          data-type="number"
          alignment="left"
          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
          :allowHeaderFiltering="false"/>

        <DxColumn
          data-field="codobj"
          caption="Cod. objeto"
          alignment="left"
          data-type="text"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false"/>
          
        <DxColumn
          data-field="status"
          caption="Status"
          alignment="left"
          data-type="text"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>
    </div>
<!-- 
    <b-modal v-model="showModalStatus" title="Editar Status" hide-footer>
      <label for="Status">Status</label>
      <form>
        {{  editData.status }}
        <b-form-select 
        id="selectStatus"
        v-model="editData.status" 
        class="form-select form-control">
          <b-form-select-option 
            value="PROCESSADOS">
            Processados
          </b-form-select-option>
        </b-form-select>
      </form>
    </b-modal> -->
    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': !dtIniFiltro,}"/>
            
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': !dtFimFiltro,}"/>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
